// extracted by mini-css-extract-plugin
module.exports = {"dialogButtons":"StartConfirmationPopup_dialogButtons__1yzl0","cancelButton":"StartConfirmationPopup_cancelButton__2ZfmQ"};